const CategoryProductsActiveFiltersSkeleton = ({ pillCount = 3 }) => {
  return (
    <div className="flex flex-wrap gap-3 animate-pulse">
      {Array.from({ length: pillCount }).map((_, index) => (
        <div
          key={`filter-pill-skeleton-${index}`}
          className="h-8 w-32 bg-grey rounded-full"
        ></div>
      ))}
    </div>
  );
};

export default CategoryProductsActiveFiltersSkeleton;
